import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import RouteTracker from "@/components/RouteTracker";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import ScanResults from "@/pages/ScanResults";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import BrokerForm from "@/pages/BrokerForm";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiesPolicy from "@/pages/CookiesPolicy";
import Terms from "@/pages/Terms";
import { bootAnalytics } from "@/lib/analytics";

export default function App() {
  useEffect(() => { bootAnalytics(); }, []);
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
        <RouteTracker />
        <Toaster richColors position="top-right" />
        <div className="App min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/scan/:scanId" element={<ScanResults />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/broker/respond/:token" element={<BrokerForm />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/legal/privacidad" element={<PrivacyPolicy />} />
              <Route path="/legal/cookies" element={<CookiesPolicy />} />
              <Route path="/legal/terminos" element={<Terms />} />
              <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute requireOnboarded><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
              <Route path="/payment/result" element={<ProtectedRoute><PaymentResult outcome="success" /></ProtectedRoute>} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentResult outcome="success" /></ProtectedRoute>} />
              <Route path="/payment/failure" element={<ProtectedRoute><PaymentResult outcome="failure" /></ProtectedRoute>} />
              <Route path="/payment/pending" element={<ProtectedRoute><PaymentResult outcome="pending" /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
